export default __webpack_public_path__ + "static/media/creditcard-face.fec50bd6.svg";